import { UserIdentity } from "react-admin"

export const getAuthorType = (identity?: UserIdentity) => {
  if (identity && identity.driverRoles && identity.driverRoles.length && typeof identity.driverRoles[0] === "string") {
    return `driver_${identity.driverRoles[0]}`
  }
  return "driver_support"
}
